import { Link } from 'react-router';
import certusLogo from '../../assets/certus-logo-primary.svg';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer id="footer-wrap" className="footer bg-light border-top mt-auto py-3">
      <div className="container-fluid but-fixed">
        <div className="row align-items-center justify-content-between">
          <div className="col-sm-12 col-xl-8 text-start">
            <p className="d-none d-xxl-inline-block align-middle mb-0 me-5">
              <img className="img-fluid" src={certusLogo} alt="Certus Logo" width="180" height="34" loading="lazy" />
            </p>
            <ul className="links d-xl-inline-block text-start text-sm-center text-xl-start align-middle mb-3 mb-sm-2 mb-xl-0">
              <li className="d-block d-sm-inline-block me-sm-3 mb-1 mb-xl-0">
                <Link to="/terms-and-conditions/">Terms &amp; Conditions</Link>
              </li>
              <li className="d-block d-sm-inline-block mx-sm-3 mb-1 mb-xl-0">
                <Link to="/privacy-policy/">Privacy Policy</Link>
              </li>
              <li className="d-block d-sm-inline-block mx-sm-3 mb-1 mb-xl-0">
                <Link to="/refund-policy/">Refund Policy</Link>
              </li>
              <li className="d-block d-sm-inline-block mx-sm-3 mb-1 mb-xl-0">
                <Link to="/contact-us/">Contact Us</Link>
              </li>
              <li className="d-block d-sm-inline-block ms-sm-3 mb-1 mb-xl-0">
                <Link to="https://fusion.certus.com/">Student Login</Link>
              </li>
            </ul>
          </div>
          <div className="col-sm- col-xl-4 text-end">
            <p className="text-start text-sm-center text-xl-end mb-0">
              Copyright &#169; {year}, Certus. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
